import { Controller } from "stimulus"

export default class extends Controller {
    static classes = ["hide"]
    static targets = ["output"]

    connect() {
        // Initialize comment sections as hidden
        this.outputTargets.forEach(element => {
            element.classList.add(this.hideClass);
        });
    }

    showthis(event) {
        if (!event || !event.params || !event.params.id) return;
        
        const targetId = event.params.id;
        
        this.outputTargets.forEach(element => {
            if (element.id === targetId) {
                // Toggle visibility of the clicked comment section
                element.classList.toggle(this.hideClass);
            } else {
                // Hide all other comment sections
                element.classList.add(this.hideClass);
            }
        });
        
        if (event.preventDefault) event.preventDefault();
    }
}
